/**
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *           _____                    _____                    _____
 *          /\    \                  /\    \                  /\    \
 *         /::\    \                /::\    \                /::\    \
 *        /::::\    \              /::::\    \               \:::\    \
 *       /::::::\    \            /::::::\    \               \:::\    \
 *      /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *     /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *    /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *   /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *  /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 * /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 * \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *  \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *   \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *    \:::\   \::::/    /              \::::/    /      \::::/____/
 *     \:::\  /:::/    /               /:::/    /        \:::\    \
 *      \:::\/:::/    /               /:::/    /          \:::\    \
 *       \::::::/    /               /:::/    /            \:::\    \
 *        \::::/    /               /:::/    /              \:::\____\
 *         \::/____/                \::/    /                \::/    /
 *          ~~                       \/____/                  \/____/
 */

import { Toast } from "antd-mobile";

const ToastDialog = {
  success(message = "") {
    Toast.success(message, 2);
  },
  info(message = "") {
    Toast.info(message, 2);
  },
  error(message = "") {
    Toast.fail(message, 2);
  },
  warning(message = "") {
    Toast.info(message, 2);
  },
  loading(message = "") {
    Toast.loading(message, 2);
  }
};

export default ToastDialog;



// WEBPACK FOOTER //
// ./src/utils/Toast.js